import React from 'react';
import { TextField, Paper, InputLabel } from '@mui/material';
import styled from 'styled-components';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const SkillsContainer = styled(Paper)`
  padding: 1rem;
  margin: 1rem 0;
  
  .quill {
    margin-bottom: 1rem;
    
    .ql-editor {
      min-height: 120px;
    }
  }
`;

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['clean']
  ]
};

const formats = [
  'bold', 'italic', 'underline',
  'list', 'bullet'
];

const SkillsForm = ({ data = '', onChange }) => {
  return (
    <SkillsContainer>
      <InputLabel style={{ marginBottom: '0.5rem' }}>技能特长</InputLabel>
      <ReactQuill
        value={data || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
      />
    </SkillsContainer>
  );
};

export default SkillsForm; 